module.exports = __webpack_public_path__ + "assets/img/4.a3a68d72.png";